import type { ApiBody, ApiResponse } from '../../api/contract';

export type WithdrawalControlStatus = ApiResponse<
  '/api/v1/partners/{partnerId}/withdrawal-policies/{policyId}',
  'get'
>['data']['status'];
export type WithdrawalVelocityDimension = ApiResponse<
  '/api/v1/partners/{partnerId}/withdrawal-velocity-rules/{ruleId}',
  'get'
>['data']['dimension'];
export type PartnerWithdrawalPolicy = ApiResponse<
  '/api/v1/partners/{partnerId}/withdrawal-policies/{policyId}',
  'get'
>['data'];
export type PartnerWithdrawalVelocityRule = ApiResponse<
  '/api/v1/partners/{partnerId}/withdrawal-velocity-rules/{ruleId}',
  'get'
>['data'];

export type CreateWithdrawalPolicyInput = ApiBody<
  '/api/v1/partners/{partnerId}/withdrawal-policies',
  'post'
>;
export type UpdateWithdrawalPolicyInput = ApiBody<
  '/api/v1/partners/{partnerId}/withdrawal-policies/{policyId}',
  'patch'
>;
export type ChangeWithdrawalControlStatusInput = ApiBody<
  '/api/v1/partners/{partnerId}/withdrawal-policies/{policyId}/status',
  'post'
>;
export interface WithdrawalPolicyFilters {
  readonly status: WithdrawalControlStatus | '';
  readonly currencyCode: string;
}

export interface WithdrawalPolicyListQuery {
  readonly page: number;
  readonly pageSize: number;
  readonly filters: WithdrawalPolicyFilters;
}

export interface WithdrawalVelocityFilters extends WithdrawalPolicyFilters {
  readonly dimension: WithdrawalVelocityDimension | '';
}

export interface WithdrawalVelocityListQuery {
  readonly page: number;
  readonly pageSize: number;
  readonly filters: WithdrawalVelocityFilters;
}

export function formatControlMoney(amount: string, currencyCode: string): string {
  const match = /^(\d+)(?:\.(\d+))?$/u.exec(amount);
  if (match === null) return `${currencyCode.trim().toUpperCase()}\u00a0${amount}`;
  const integer = (match[1] ?? '').replace(/\B(?=(\d{3})+(?!\d))/gu, ',');
  const fraction = (match[2] ?? '').replace(/0+$/u, '').padEnd(2, '0');
  return `${currencyCode.trim().toUpperCase()}\u00a0${integer}.${fraction}`;
}
